import React from "react";
import { useNavigate } from "react-router";
import { FormattedMessage } from "react-intl";
import { ICON_TYPE } from "components/Icon";
import { useAuth, useLinks, useLogout } from "hooks";
import { SideNavLink } from "components/Nav/SideNav";

/**
 * MenuItemLogout
 */
const MenuItemLogout = () => {
  const { isShowcase } = useAuth();
  const { handleLogout, loading } = useLogout();
  const links = useLinks();
  const navigate = useNavigate();

  return (
    <SideNavLink disabled={loading} onClick={() => handleLogout(() => navigate(links.login))} type={ICON_TYPE.logout}>
      <FormattedMessage id={`Global.${isShowcase ? "EndSession" : "Logout"}`} />
    </SideNavLink>
  );
};

export default MenuItemLogout;
